import React from 'react';
import './collaborators.scss';

import {handleAuthError, useCheckUserAuthentication,fetchLookup} from '../../globals';
import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  MasterDetail,
  Toolbar,
  Lookup,
  Editing,
  Selection,
  SearchPanel
} from 'devextreme-react/data-grid';

import { Item} from 'devextreme-react/form';
import { CheckBox } from 'devextreme-react/check-box';
import { useState, useEffect } from "react";
//import { useAuth } from  '../../contexts/auth'; 
//import {Logout} from '../../globals';
import collaboratorDocs from './collaboratorDocs.js';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore'

export default function Collaborators() {

  const [isActive, setIsActive] = useState(true);
  const [users, setUsers] = useState({});

   const user = useCheckUserAuthentication();

  // const { user } = useAuth(); 

  // if (!user) 
  //   Logout();

  const filterPayload = { 
    isAttivo: isActive
  };

  const remoteDataSource = createStore({
    key: 'id',
    loadUrl: serviceUrl + '/Find',
     onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
        var payload = ajaxOptions.data;
        payload.values = JSON.stringify(filterPayload);
        ajaxOptions.data = payload;          
      }     
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction',

    errorHandler: (error) => {
      handleAuthError(error);
    }
    
  });

  function onCheckValueChanged(e)  {
    setIsActive(e.value);
  };

  const addButtonOptions = {
    icon: 'plus',
    hint: 'Nuovo Collaboratore'
  };

  useEffect(() => {
  
    const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Users';
    var newUrl1 =  newServiceUrl1 + "/GetAction";

    
    // const requestOptions = {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer ${user.token}`
    //   }
    // };

    const fetchData = async () => {
    
      if (!user?.token) {
      return;
    }
      
    try {

      const requestOptions = {
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      };

      const json1 = await fetchLookup(newUrl1,requestOptions);
      if (json1) {
        setUsers(json1);
      }

    // const fetchData = async () => {
    //   try {
    //     const response1 = await fetch(newUrl1, requestOptions);
    //     const json1 = await response1.json();
    //     console.log(json1);
    //     setUsers(json1);

    //   } catch (error) {
    //     console.log("error", error);
    //   }
    // };

   } catch (error) {
        console.log("error", error);
      }
    };
      fetchData();
    }, [user?.token]); // Aggiorna se il token cambia


  return(
  <React.Fragment>
    <h2 className={'content-block'}>Collaboratori</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>

      <DataGrid
        dataSource={remoteDataSource}
        focusedRowEnabled={true}
      >
          <Toolbar>
          
            <Item name="addRowButton"  options={addButtonOptions} location="before"/>
            <Item location="after">
              <CheckBox  
                value={isActive} onValueChanged={onCheckValueChanged}
                defaultValue={isActive}
                text="  Solo Attivi   "
              >
              </CheckBox>
            </Item>    
            
            <Item name="searchPanel" className="offer-toolbar"/>
          
          </Toolbar>
        <SearchPanel visible={true} width={240} placeholder="Cerca..." />
        <Selection mode="single" />
        <Editing
          mode="row"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}     
        />
        <Column dataField="id" visible={false}/>
        <Column dataField="nome" />
        <Column dataField="cognome" />
        <Column dataField="società" />
        <Column dataField="email" />
        <Column dataField="cellulare" />
        <Column dataField="telefono" />
        <Column dataField="risorsa" />
        <Column dataField="gestore" />
        <Column dataField="isActive" caption="Attivo" width={80}/>
        <Column dataField="userId" caption="Utente" >
          <Lookup dataSource={users} displayExpr="name" valueExpr="id" />
        </Column>

        <MasterDetail
          enabled={true}
          component={collaboratorDocs}
        />

      </DataGrid>  
      </div>
    </div>
  </React.Fragment>
  )
};